function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("rect", {
  width: 15,
  height: 15,
  fill: "none"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Icon_Location_On_Rounded",
  "data-name": "Icon / Location On / Rounded",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Box",
  width: 15,
  height: 15,
  fill: "none"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_2037",
  "data-name": "Path 2037",
  d: "M296.334,54.7a1.7,1.7,0,1,1,1.941-1.684A1.854,1.854,0,0,1,296.334,54.7Zm0-6.4c-3.028,0-5.434,2.088-5.434,4.714,0,2.828,3.416,6.667,4.813,8.148a.8.8,0,0,0,1.164,0c1.4-1.481,4.813-5.32,4.813-8.148C301.768,50.388,299.362,48.3,296.334,48.3Z",
  transform: "translate(-288.858 -47.342)",
  fill: "#fff"
}));

function SvgIconLocation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLocation);
export default __webpack_public_path__ + "static/media/icon-location.98c2ac1b.svg";
export { ForwardRef as ReactComponent };